import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PimplesPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Pimples and Acne</h1>
        <section className="mb-8">
          <p>Pimples and acne are common skin conditions that can affect people of all ages. Our natural therapies focus on addressing the root causes of acne, including hormonal imbalances, digestive issues, and skin inflammation, while promoting clear, healthy skin through gentle, effective herbal remedies.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Hormonal imbalances</li>
            <li>Poor diet</li>
            <li>Stress</li>
            <li>Digestive issues</li>
            <li>Improper skin care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Red, inflamed pimples</li>
            <li>Blackheads and whiteheads</li>
            <li>Oily skin</li>
            <li>Skin sensitivity</li>
            <li>Scarring in severe cases</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use skin-clearing herbs, detoxifying agents, and lifestyle modifications to naturally treat pimples and acne. Our approach focuses on balancing hormones, improving digestion, and promoting healthy skin through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural skin clearing</li>
            <li>No harsh side effects</li>
            <li>Long-term results</li>
            <li>Improved overall skin health</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain proper skin hygiene</li>
            <li>Follow a balanced diet</li>
            <li>Manage stress levels</li>
            <li>Avoid touching face frequently</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see results?</strong>
            <p>A: Many patients notice improvement within 4-6 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment suitable for all skin types?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all skin types, including sensitive skin.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Will the treatment prevent future breakouts?</strong>
            <p>A: Our holistic approach addresses underlying causes, helping to prevent future breakouts.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Achieve clear, healthy skin—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default PimplesPage; 